import moment from '../vendor/moment/dist/moment.js';
export const END_TIME = moment('2026-08-19 2:00 AM EDT', ['YYYY-MM-DD hh A z']);
export const MESSAGE = `Parts of Arctic Wolf's Managed Risk Dashboard will be inaccessible or have impacted functionality during the following times:
Australia: August 19, 12–4 pm AEST (August 19 from 2–6 am UTC)
Europe: August 19, 2–6 am CEST (August 19 from 12–4 am UTC)
North America: August 18, 10 pm to August 19, 2 am EDT (August 19 from 2–6 am UTC)
If you have any questions about scheduled maintenance, contact us at `;
export const DAYS_TO_SHOW_BANNER = 14;
